import LogInCode from "components/LogIn/LogInCode";
import LogInNumber from "components/LogIn/LogInNumber";
import React, { useState } from "react";
const Modal = () => {
  const [modal, setmodal] = useState(0);
  const [loginkey, setloginkey] = useState("");
  const [number, setnumber] = useState("");

  let SetNumber = (e) => {
    setnumber(e.target.value);
  };
  function changemodal(modalNumber) {
    setmodal(modalNumber);
  }
  function LoginKey(loginKey) {
    setloginkey(loginKey);
  }
  function Back() {
    setmodal(0);
  }
  return (
    <>
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen-lg-down modal-lg">
          <div class="modal-content ">
            <div className="modal-header d-flex flex-row justify-content-between">
              {modal == 0 ? (
                ""
              ) : (
                <button
                  type="button"
                  className="btn border"
                  style={{ boxShadow: "none" }}
                  onClick={Back}
                >
                  بازگشت
                </button>
              )}
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="CloseModal"
              ></button>
            </div>

            {modal == 0 ? (
              <LogInNumber
                SetNumber={SetNumber}
                number={number}
                login={LoginKey}
                ChangeModal={changemodal}
              />
            ) : (
              <LogInCode
                ChangeModal={changemodal}
                loginkey={loginkey}
                SetNumber={SetNumber}
                number={number}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
